import { useSelector } from 'react-redux';

import { getAgeByBirthDate } from '../../utils';
import { collegeProspectMaxAge, collegeProspectMinAge } from '../../utils/constants';
import { useCPPDynamicConfig } from './useCPPDynamicConfig';
import useCollegeProspectAccess from './useCollegeProspectAccess';

const useCppCollegeTeamsAccess = () => {
    const { isCollegeProspectPowerEnabled } = useCPPDynamicConfig();
    const { hasAnnualPower } = useCollegeProspectAccess();
    const user = useSelector((state) => state.auth?.user);

    const age = getAgeByBirthDate(user?.claimedPlayer?.birthDate || user?.birthdate);
    const isEligibleAge = !!age && age >= collegeProspectMinAge && age <= collegeProspectMaxAge;
    const isEligible = isCollegeProspectPowerEnabled && hasAnnualPower && isEligibleAge;

    return { isEligible, viewerGender: user?.gender || null };
};

export default useCppCollegeTeamsAccess;
